import Colors from '@dynatrace/strato-design-tokens/colors';

import { DEFAULT_GAP_WIDTH } from '../../shared/constants.js';

interface MeterBarIndicatorProps {
  position: number;
}

const INDICATOR_WIDTH = 2;

export const MeterBarChartThresholdIndicator = ({
  position,
}: MeterBarIndicatorProps) => {
  return (
    <rect
      x={position - DEFAULT_GAP_WIDTH}
      y={0}
      width={INDICATOR_WIDTH}
      height="100%"
      fill={Colors.Icon.Neutral.Default}
    ></rect>
  );
};
